// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemValidationColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { MinusCircleOutlined } from '@ant-design/icons';
import DocumentValidationTag from 'components/core/DocumentValidationTag';
import { resolveItemFontSize } from './index';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the item-level validation status column.
// Adapts item._validation to the format expected by DocumentValidationTag.
function itemValidationColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 12);
  return {
    title: '',
    dataIndex: '_validation',
    width: 30,
    align: 'center',
    sorter: (a, b) => {
      const aValid = a?._validation?.isValid;
      const bValid = b?._validation?.isValid;
      // Sort: invalid first, then valid, then undefined
      if (aValid === bValid) return 0;
      if (aValid === false) return -1;
      if (bValid === false) return 1;
      if (aValid === true) return -1;
      return 1;
    },
    render: (_, item) => {
      if (!item?._validation) {
        return <MinusCircleOutlined style={{ color: '#d9d9d9', fontSize }} />;
      }
      // Map item._validation.errors to errorList (DocumentValidationTag expects errorList)
      const adaptedValidation = {
        isValid: item._validation.isValid,
        errorList: item._validation.errors || item._validation.errorList || [],
        warningList: item._validation.warnings || item._validation.warningList || [],
      };
      return (
        <DocumentValidationTag
          data={{ documentValidation: adaptedValidation }}
          style={{ fontSize }}
        />
      );
    },
  };
}

export default itemValidationColumn;
